import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="text-6xl font-bold text-gray-300 mb-4">
            404
          </div>
          <h1 className="text-2xl font-bold mb-2">
            Página não encontrada
          </h1>
          <p>
            A página que você está procurando não existe ou foi movida.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            <Home size={16} />
            <span>Voltar ao Início</span>
          </Link>

          <div className="flex space-x-3">
            <button
              onClick={() => window.history.back()}
              className="flex-1 inline-flex items-center justify-center space-x-2 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              <ArrowLeft size={16} />
              <span>Voltar</span>
            </button>

            <button
              onClick={() => window.location.reload()}
              className="flex-1 inline-flex items-center justify-center space-x-2 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              <Search size={16} />
              <span>Recarregar</span>
            </button>
          </div>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          <p>Se você acredita que isso é um erro, entre em contato conosco.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 